import { useMemo } from 'react';
import useUserGeoLocation from '~/client/shared/form/FormPhoneNumber/hooks/useUserGeoLocation';
import emailSuggestionByCountry from '~/../public/public-casino/email-suggestion-by-country.json';

const defaultEmails = ['gmail.com', 'yahoo.com', 'hotmail.com'];

const useEmailSuggestion = () => {
  const { userGeoCountryCode } = useUserGeoLocation();

  const suggestedEmails = useMemo(
    () =>
      emailSuggestionByCountry.find(
        (country) => country.countryCode === userGeoCountryCode,
      ),
    [userGeoCountryCode],
  );

  const selectedEmails = suggestedEmails
    ? suggestedEmails.mails
    : defaultEmails;

  return selectedEmails;
};

export default useEmailSuggestion;
